import React, { useState, useEffect } from "react";
import ArrowUpwardIcon from "@mui/icons-material/ArrowUpward";
import { useTour } from "../../context/TourContext";
import { useLocation } from "react-router-dom";
import { ROUTES } from "../../constants";
import "./ScrollToTop.css";

const ScrollToTop = () => {
    const [isVisible, setIsVisible] = useState(false);
    const location = useLocation();
    const { hasTourSteps } = useTour();

    const toggleVisibility = () => {
        if (window.pageYOffset > 300) {
            setIsVisible(true);
        } else {
            setIsVisible(false);
        }
    };

    const scrollToTop = () => {
        const startPosition = window.pageYOffset;
        const duration = 600;
        const startTime = performance.now();

        const animateScroll = (currentTime) => {
            const elapsed = currentTime - startTime;
            const progress = Math.min(elapsed / duration, 1);
            const easeInOutQuad = progress < 0.5 
                ? 2 * progress * progress 
                : -1 + (4 - 2 * progress) * progress;

            window.scrollTo(0, startPosition * (1 - easeInOutQuad));

            if (progress < 1) {
                requestAnimationFrame(animateScroll);
            }
        };

        requestAnimationFrame(animateScroll);
    };

    useEffect(() => {
        window.addEventListener("scroll", toggleVisibility);
        return () => window.removeEventListener("scroll", toggleVisibility);
    }, []);

    // Check if we're on a public route
    const isPublicRoute = [
        ROUTES.LOGIN,
        ROUTES.REGISTER,
        ROUTES.FORGOT_PASSWORD,
        ROUTES.RESET_PASSWORD,
        ROUTES.VERIFY_EMAIL,
        ROUTES.ACCEPT_EULA,
        ROUTES.LOGOUT
    ].some(route => location.pathname.startsWith(route));

    // Determine if tour button is showing
    const showTourButton = !isPublicRoute && hasTourSteps();

    // Calculate bottom position
    // If tour button exists: 90 (tour) + 50 (height) + 10 (gap) = 150px
    // If no tour button: 30 (chatbot) + 50 (height) + 10 (gap) = 90px
    const bottomPosition = showTourButton ? "150px" : "90px";

    return (
        <div 
            className={`scroll-to-top ${isVisible ? "show" : ""}`} 
            onClick={scrollToTop}
            style={{ bottom: bottomPosition }}
        >
            <ArrowUpwardIcon />
        </div>
    );
};

export default ScrollToTop;